import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import styles from "./PendingCertification.module.css";

// Status supplied by the site owner. Pending is not an awarded certification.
export default function PendingCertification({ prominent = false, linkToQuality = true, animate = false }) {
  const panelRef = useRef(null);
  const playedRef = useRef(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (!animate || !window.matchMedia || !window.IntersectionObserver) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer;
    const watch = () => {
      observer?.disconnect();
      if (preference.matches) { setEntered(false); return; }
      if (playedRef.current) return;
      observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        playedRef.current = true;
        setEntered(true);
        observer.disconnect();
      }, { threshold: 0.35 });
      if (panelRef.current) observer.observe(panelRef.current);
    };
    watch();
    preference.addEventListener?.('change', watch);
    return () => { observer?.disconnect(); preference.removeEventListener?.('change', watch); };
  }, [animate]);

  return <section ref={panelRef} className={`${styles.status} ${prominent ? styles.prominent : ''} ${animate ? styles.motionPanel : ''} ${entered ? styles.entered : ''}`} aria-label="AS9100 certification status" data-testid="as9100-pending-status" data-motion={animate ? (entered ? 'entered' : 'static') : undefined}>
    {animate && <span className={styles.sweep} aria-hidden="true" />}
    <div className={styles.inner}>
      <div>
        <p className={styles.eyebrow}>Quality certification status</p>
        <h2 className={styles.title}>AS9100 <span>Certification Pending</span></h2>
      </div>
      {linkToQuality && <Link to="/quality-testing" className={styles.link}>Quality &amp; Testing <ArrowUpRight size={18} aria-hidden="true" /></Link>}
    </div>
  </section>;
}
